import type { IOrderTracking } from '../interfaces';

// biome-ignore lint/suspicious/noExplicitAny: order tracking data has dynamic shape from API
export const mapOrderTracking = (orderTracking: any): IOrderTracking | undefined => {
  if (!orderTracking) return undefined;

  return {
    orderId: orderTracking.order_id,
    orderSourceName: orderTracking.order_source_name,
  };
};
